<template>
  <v-row>
    <v-col cols="6" md="4" offset-sm="1">
      <div class="title-upload-container">{{$t('pages.agreementConclusionChangeOwner.requiredDocuments')}}</div>
      <div class="pa-6 upload-container">
        {{$t('pages.agreementConclusionChangeOwner.documentLandPlot')}} *
        <file-form
          fileType="802740000"
          @transferData="setFile"
          :income="files['802740000']"
        ></file-form>

        {{$t('pages.agreementConclusionChangeOwner.documentPassport')}} *
        <file-form
          fileType="802740001"
          @transferData="setFile"
          :income="files['802740001']"
        ></file-form>
        <div v-if="ObjectLocateType">
        {{$t('pages.agreementConclusionChangeOwner.documentLocate')}} *
          <file-form
            fileType="802740016"
            @transferData="setFile"
            :income="files['802740016']"
          ></file-form>
        </div>
        <div v-if="see && files['802740072'].masFiles.length">
          Согласие на обработку и передачу ПД *
          <file-form
            fileType="802740072"
            @transferData="setFile"
            :income="files['802740072']"
          ></file-form>
        </div>
        <div v-if="edit && files['802740072'].masFiles.length">
          Согласие на обработку и передачу ПД *
          <div
            v-for="item in files['802740072'].masFiles"
            :key="item.fileName"
            class="grey--text py-3"
          >
            <v-icon small class="grey--text">mdi-file</v-icon>
            {{ item.fileName }}
          </div>
        </div>
      </div>

      <div class="pa-6" v-if="!ObjectLocateType">
        {{$t('pages.agreementConclusionChangeOwner.documentLocate')}}
        <file-form
          fileType="802740016"
          @transferData="setFile"
          :income="files['802740016']"
        ></file-form>
      </div>

      <div class="pa-6">
        {{$t('pages.agreementConclusionChangeOwner.documentMeteringDevice')}}
        <file-form
          fileType="802740059"
          @transferData="setFile"
          :income="files['802740059']"
        ></file-form>

        {{$t('pages.agreementConclusionChangeOwner.documentINN')}}
        <file-form
          fileType="802740002"
          @transferData="setFile"
          :income="files['802740002']"
        ></file-form>
      </div>

      <div class="sub-information-container">
        <p class="mt-0 mb-2">
          {{$t('pages.agreementConclusionChangeOwner.maxSizeFile')}}- 20 Мб <br />
          {{$t('pages.agreementConclusionChangeOwner.fileFormats')}}: .pdf, .jpg, .jpeg,
          .bmp, .gif
        </p>
      </div>
    </v-col>

    <v-col cols="6" md="4" offset-sm="2">
      <v-form v-model="validForm">
        <div class="mb-3 body-1 font-weight-medium">
          E-mail: <span v-if="emailCheck">*</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" style="color: dodgerblue" small
                >mdi-help-circle</v-icon
              >
            </template>
            <span
              >{{$t('pages.agreementConclusionChangeOwner.notificationContract')}}.</span
            >
          </v-tooltip>
        </div>
        <v-text-field
          v-if="emailCheck || ObjectLocateType"
          v-model="email"
          outlined
          :rules="emailRules"
        ></v-text-field>
        <v-text-field
          v-if="mail && !ObjectLocateType"
          v-model="email"
          outlined
          :rules="emailRulesForMailCheck"
        >
        </v-text-field>
        <div class="mb-3 body-1 font-weight-medium">
          {{$t('pages.agreementConclusionChangeOwner.deliveryMethod')}}
        </div>
        <v-checkbox
          :label="$t('pages.agreementConclusionChangeOwner.byEmail')"
          color="#39b54a"
          class="mt-0"
          v-model="emailCheck"
          @change="changeEmailCheck"
          :disabled="emailCheck"
        ></v-checkbox>

        <v-checkbox
          :label="$t('pages.agreementConclusionChangeOwner.byPostal')"
          color="#39b54a"
          class="mt-0"
          v-model="mail"
          @change="changeMail"
          :disabled="mail"
        ></v-checkbox>

        <!--   <div class="mb-3 body-1 font-weight-medium">
          Офис клиентского обслуживания: *
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" style="color: dodgerblue" small >mdi-help-circle</v-icon>
            </template>
            <span>Укажите офис клиентского обслуживания (ОКО) по территориальной принадлежности адреса объекта.</span>
          </v-tooltip>
        </div> 

        <v-select
          :items="okoItems"
          v-model="okoSelect"
          item-text="text"
          :loading="!okoItems.length"
          :disabled="!okoItems.length"
          no-data-text="Загрузка"
          return-object
          outlined
        ></v-select> -->
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import FileForm from "../components/partial/FileFormMulti";
import { AxiosWrapper } from "@/assets/api/AxiosWrapper";
import FieldWithTitle from "../components/partial/FieldWithTitle";

export default {
  props: ["income", "formData"],
  components: {
    FileForm,
    FieldWithTitle,
  },
  data: () => ({
    email: "",
    email2: "",
    ObjectLocateType: null,
    okooffice: null,
    okoItems: [],
    okoSelect: {},
    okoname: null,
    okocode: null,
    emailCheck: true,
    mail: false,

    // DATA
    files: {
      802740000: null,
      802740001: null,
      802740002: null,
      802740016: null,
      802740059: null,
    },
    edit: false,
    see: false,
    validForm: false,
  }),
  computed: {
    dataIsValid() {
      if (this.ObjectLocateType) {
        // console.log(this.files);
        return (
          this.files["802740000"] !== null &&
          this.files["802740001"] !== null &&
          this.files["802740016"] !== null &&
          this.validForm &&
          this.files["802740000"].masFiles.length > 0 &&
          this.files["802740001"].masFiles.length > 0 &&
          this.files["802740016"].masFiles.length > 0
        );
      } else {
        return (
          this.files["802740000"] !== null &&
          this.files["802740001"] !== null &&
          this.validForm &&
          this.files["802740000"].masFiles.length > 0 &&
          this.files["802740001"].masFiles.length > 0
        );
      }
    },
    emailRules() {
      return [
      (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || this.$t('pages.agreementConclusionChangeOwner.incorrectEmail');
      },
      ]
    },
    emailRulesForMailCheck(){
      return [
      (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return value === null || pattern.test(value) || this.$t('pages.agreementConclusionChangeOwner.incorrectEmail');
      },
      ]
    }
  },
  methods: {
    changeMail() {
      if (this.email == null || this.email == "") this.email = null;
      this.emailCheck = !this.mail;
    },
    changeEmailCheck() {
      if (this.email == null || this.email == "") this.email = "";
      this.mail = !this.emailCheck;
    },

    transferData() {
      // DATA
      //  console.log(this.files);
      this.$emit("transfer", {
        files: this.files,
        okooffice: this.okooffice,
        email: this.email,
        emailCheck: this.emailCheck,
      });
    },
    setFile(payload) {
      this.files[payload.fileType] = payload;
    },

    getOko() {
      /*   AxiosWrapper.get("GetOko").then((response) => {
        this.okoItems = response.data;
        this.okoItems.forEach((it) => (it.text = it.okoname));
        if (this.okooffice) {
          this.okoSelect = this.okoItems.find(
            (it) => it.okocode === this.okooffice
          );
        }
      }); */
    },
  },
  created() {
    if (this.income && this.income.files) {
      this.email = this.income.email;
      this.okooffice = this.income.okooffice;

      if (this.income.emailCheck === true) {
        this.emailCheck = this.income.emailCheck;
        this.mail = false;
      } else {
        this.emailCheck = false;
        this.mail = true;
      }
      let keys = Object.keys(this.income.files);
      keys.forEach((key) => {
        this.files[key] = this.income.files[key];
      });
    }
    if (window.location.href.indexOf("type=edit") > -1) {
      this.edit = true;
    }
    if (window.location.href.indexOf("type=see") > -1) {
      this.see = true;
    }
    this.getOko();
  },

  mounted() {
    if (this.formData) {
      this.ObjectLocateType = this.formData.objectLocateType;
    }
    if (this.formData && this.formData.files) {
      this.email = this.formData.email;

      if (this.formData.emailCheck === true) {
        this.emailCheck = this.formData.emailCheck;
        this.mail = false;
      } else {
        this.emailCheck = false;
        this.mail = true;
      }
      let keys = Object.keys(this.formData.files).filter(key => this.formData.files[key] !== null);
      keys.forEach((key) => {
        if (this.formData.files[key].fileType) {
          this.files[this.formData.files[key].fileType] =
            this.formData.files[key];
        }
      });
      
    }

  },

  watch: {
    okoSelect: {
      immediate: true,
      handler: function (payload) {
        this.okooffice = payload.okocode;
      },
    },
    dataIsValid: {
      immediate: true,
      handler: function (value) {
        this.$emit("lockFwdBtn", !value);
      },
    },
  },
};
</script>

<style lang="scss">
.title-upload-container {
  color: grey;
}

.upload-container {
  border: 5px solid lightgray;
}

.sub-information-container {
  margin-top: 20px;
  padding-left: 0;
  border-top: 3px solid lightgray;
  border-bottom: 3px solid lightgray;
}
</style>
